module.exports = __webpack_public_path__ + "media/images/_anim-bg-99172e582832df814b924fd86a9b3800.gif";